import { getApi } from "../helpers/api";

async function remove(endpoint: string, id: number) {
  return getApi().delete(`/${endpoint}/${id}`);
}

export default remove;
